import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase configuration. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY environment variables.');
  console.error('Current values:', { 
    supabaseUrl: supabaseUrl ? 'Set' : 'Not set', 
    supabaseAnonKey: supabaseAnonKey ? 'Set' : 'Not set' 
  });
  console.error('Please create a .env.local file with your Supabase credentials.');
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  }
);

// Database table names
export const TABLES = {
  USERS: 'users',
  CATEGORIES: 'categories',
  LOCATIONS: 'locations',
  SUPPLIERS: 'suppliers',
  VEHICLE_PARTS: 'vehicle_parts',
  STOCK_MOVEMENTS: 'stock_movements',
  INVOICES: 'invoices',
  INVOICE_ITEMS: 'invoice_items'
} as const;
